import { FormsModule } from '@angular/forms';
import { MonitoredDataInputComponent } from './monitored-data-input.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ElasticInputDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CurrencyMaskModule,
        ElasticInputDirectiveModule,
    ],
    exports: [ MonitoredDataInputComponent ],
    declarations: [ MonitoredDataInputComponent ],
})
export class MonitoredDataInputModule { }
